import type { IResponseEventStats } from "./event.types";
import Event from "./event.model";
import useRequest from "~/hooks/use-request";

const EventStatsAPI = {
  getEventScoreStatsById(id: string): Promise<IEventStats> {
    const { request } = useRequest();

    return request
      .get<IContentResponse<IResponseEventStats>>("/api/event/stats", { setAuthorization: true, query: { id, score: true, overview: true } })
      .then((res) => {
        const scores = Event.formatScoreStats(res.content?.vidswap?.["game-scores"]);
        const overview = Event.formatGameStats(res.content?.vidswap?.["game-overview"]);

        return { scores, overview };
      });
  },
};

export default EventStatsAPI;
